import { useSelector } from 'react-redux';
import { getGtkmShowingErrorModal } from '../store/gtkm/selector';
import { getPreviousStep } from '../store/flow/selectors';
import { Step } from 'signup-constants/Step';
import { isAssignedToGTKMExperiment } from '../utils/gtkm/isAssignedToGTKM';
export const useShowErrorModal = () => {
  const showGTKMErrorModal = useSelector(getGtkmShowingErrorModal);
  const previousStep = useSelector(getPreviousStep);
  const isAssignedToGTKM = useSelector(isAssignedToGTKMExperiment);
  const isPreviousStepCompanyDomain = previousStep === Step.CompanyDomain;
  const renderGTKMErrorModal = isAssignedToGTKM && isPreviousStepCompanyDomain && showGTKMErrorModal;
  return {
    showErrorModal: renderGTKMErrorModal
  };
};